import React, { useEffect, useState, useContext } from "react";
import { appServerSideProps } from "../../utils/getAppService";
import { v4 as uuidv4 } from "uuid";
import FirstScreen from "./FirstScreen";
import SecondScreen from "./SecondScreen";
import ThirdScreen from "./ThirdScreen";
import Head from "next/head";
import MainLayout from "../../components/MainLayout/MainLayout";
import { useCookies } from "react-cookie";
import { AppContext } from "../../context/state";
import { Form, Row, InputGroup, Button, Col } from "react-bootstrap";
import Utils from "../../utils/Utils";
import SQBestBetsSreenshot from "../../assets/images/SQBestBetsSreenshot.png";
import { SIGNUPS_CLOSED_MESSAGE } from "../../constants/main";

const MiscStats = ({ user }) => {
  const [cookies] = useCookies(["token_access, name"]);
  const { store, setStore } = useContext(AppContext);
  const { leagueType } = store;
  const [screen, setScreen] = useState("first");
  const [parameters, setParameters] = useState([]);
  const [manuallyReset, setManuallyReset] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [uniqUserId, setUniqUserId] = useState("");

  const isStandardPlan = Utils.hasStandardPlan(user) || Utils.hasTrial(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user);
  const isPaidPlan = (isStandardPlan || isPremiumPlan) && user?.has_paid;

  useEffect(() => {
    document.title = "ShotQuality Bets | Betting Model";

    setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());

    if (window.localStorage) {
      if (!user) {
        if (localStorage.getItem("uniqUserId") === null) {
          const newUserId = uuidv4();
          localStorage.setItem("uniqUserId", newUserId);
          setUniqUserId(newUserId);
        } else {
          setUniqUserId(localStorage.getItem("uniqUserId"));
        }
      }
    }

    if (leagueType !== "college_mens") {
      setStore({ ...store, leagueType: "college_mens" });
    }

    // Temporary work only with college_mens league
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/college_mens/model-sandbox/parameters`)
      .then((d) => d.json())
      .then((response) => setParameters(response.data))
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <>
      <Head>
        <meta
          property="description"
          content='Create your own college basketball model with our easy-to-use tool. Customize your model by choosing your stats to get a
personalized prediction for every game. Our advanced algorithms take into account a variety of factors to give you the most accurate predictions.
Try it out now and see how your model stacks up against the competition!"
Create your own winning college basketball model with our Make-Your-Own page. Choose from a variety of customizable options to build a
model that accurately predicts game outcomes based on player stats, team history, and current matchups. Get the edge over your competition
and make your own college basketball model now!"'
        />
      </Head>
      <MainLayout>
        <main id="ContentBox" style={{ minHeight: "100vh" }}>
          <div className="MiscStats Sandbox">
            {!isPaidPlan ? (
              <div className="col-md-12 dummyLockWrapper" style={{ height: "100vh", background: "#e4e5e9" }}>
                <div className="imgWrapper">
                  <img src={SQBestBetsSreenshot.src} className="bracketBackground" alt="" />
                </div>

                <Col
                  className="dummyLock"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  <h3>Want to see more?</h3>
                  <p>{SIGNUPS_CLOSED_MESSAGE}</p>
                  <div className="requestEmailWrapper">
                    <Row className="mm-email-wrapper">
                      <Form className="mm-form">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <InputGroup className="mb-3 mm-input-main-wrapper">
                            {user ? null : (
                              <Button
                                className={`mm-access-button mx-auto`}
                                style={{
                                  backgroundColor: "#f26b0b",
                                  color: "white",
                                  padding: "10px 30px",
                                  border: "none",
                                }}
                                onClick={() => router.push("/login")}
                              >
                                Sign In
                              </Button>
                            )}
                          </InputGroup>
                        </Form.Group>
                      </Form>
                    </Row>
                  </div>
                </Col>
              </div>
            ) : (
              <>
                {screen === "first" && (
                  <FirstScreen
                    cookies={cookies}
                    setScreen={setScreen}
                    parameters={parameters}
                    authToken={authToken}
                    manuallyReset={manuallyReset}
                    setManuallyReset={setManuallyReset}
                    user={user}
                    uniqUserId={uniqUserId}
                  />
                )}
                {screen === "second" && (
                  <SecondScreen
                    cookies={cookies}
                    setScreen={setScreen}
                    setManuallyReset={setManuallyReset}
                    authToken={authToken}
                    uniqUserId={uniqUserId}
                    user={user}
                  />
                )}
                {screen === "third" && <ThirdScreen cookies={cookies} setScreen={setScreen} />}
              </>
            )}
          </div>
        </main>
      </MainLayout>
    </>
  );
};

export default MiscStats;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return { props: { user } };
});
